export const percentage = (initial: number, left: number) => {
  if (!initial && !left) {
    return 0;
  }
  return 100 - (left / initial) * 100;
};
